import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const commodityProductSlice = createSlice({
  name: "commodityProduct",

  initialState: {
    commodityProductData: [],
    isError: false,
  },

  reducers: {
    fetchCommodityProductSuccess: (state, action) => {
      state.isError = false;
      state.commodityProductData = action.payload;
    },
    fetchCommodityProductFailure: (state) => {
      state.isError = true;
    },
    resetCommodityProduct: (state) => {
      state.isError = false;
      state.commodityProductData = [];
    },
  },
});

export const {
  fetchCommodityProductSuccess,
  fetchCommodityProductFailure,
  resetCommodityProduct,
} = commodityProductSlice.actions;

export const fetchCommodityProduct = (logout) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${config.apiUrl}/seller/my-commodity-product-list`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: config.token,
          Accept: "application/json",
        },
      }
    );

    dispatch(fetchCommodityProductSuccess(response.data.data));
  } catch (error) {
    dispatch(fetchCommodityProductFailure());
    if (error.response && error.response.status === 401) {
      logout();
    }
  }
};

export default commodityProductSlice.reducer;
